import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Renders the brand hero background using the real 4CEE gradient hero video,
 * scaled to cover the hero section and tinted to blend with the brand palette.
 */
@Component({
  selector: 'app-brand-hero-background',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <video
      class="brand-hero-video"
      src="./assets/video/gradient-hero.mp4"
      autoplay
      muted
      loop
      playsinline
      disablepictureinpicture
      aria-hidden="true">
    </video>
  `,
  styles: [`
    :host {
      display: block;
      position: absolute;
      inset: 0;
      overflow: hidden;
    }
    .brand-hero-video {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      /* Slightly desaturated/darkened so foreground text and tiles keep contrast. */
      filter: saturate(1.05) brightness(0.85);
    }
  `]
})
export class BrandHeroBackground {}
